"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AdvertiseWithUsDynamic = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get5 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AdvertiseWithUsDynamic = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(AdvertiseWithUsDynamic, _React$Component);

  var _super = _createSuper(AdvertiseWithUsDynamic);

  function AdvertiseWithUsDynamic() {
    (0, _classCallCheck2["default"])(this, AdvertiseWithUsDynamic);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(AdvertiseWithUsDynamic, [{
    key: "componentDidMount",
    value: // eslint-disable-next-line react/sort-comp
    function componentDidMount() {
      var _this$props = this.props,
          serviceProviderId = _this$props.serviceProviderId,
          userId = _this$props.userId,
          contactCountByTopCategoryResponse = _this$props.contactCountByTopCategoryResponse;

      var _get3 = (0, _get5["default"])(contactCountByTopCategoryResponse, 'categoryGroupContacts', false),
          categoryGroupId = _get3.categoryGroupId,
          contactCount = _get3.contactCount;

      _angieslistAppPlatform.tracker.track('Item Displayed', {
        activityLocation: 'Unified Header',
        contactCountDisplayed: contactCount,
        categoryGroupId: categoryGroupId,
        description: 'Advertise With Us',
        serviceProviderId: serviceProviderId,
        userId: userId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          advertiseRequest = _this$props2.advertiseRequest,
          advertiseRequestPending = _this$props2.advertiseRequestPending,
          contactCountByTopCategoryResponse = _this$props2.contactCountByTopCategoryResponse,
          activityLocation = _this$props2.activityLocation;

      var _get4 = (0, _get5["default"])(contactCountByTopCategoryResponse, 'categoryGroupContacts', false),
          categoryGroupId = _get4.categoryGroupId,
          contactCount = _get4.contactCount,
          categoryGroupName = _get4.categoryGroupName;

      var categorySegmentData = {
        categoryGroupId: categoryGroupId,
        contactCountDisplayed: contactCount
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "advertise-with-us-dynamic",
        style: {
          marginTop: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        style: {
          textAlign: 'center',
          padding: '15px 0px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12,
        id: "office-home--advertise-with-us"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Angi delivered more than", ' ', contactCount, ' ', "contacts in", ' ', categoryGroupName, ' ', "to all Advertisers in your service area in the last 90 days.")), /*#__PURE__*/_react["default"].createElement("p", {
        style: {
          marginBottom: 10
        },
        id: "office-home--advertise-with-us--text"
      }, "Ready to start advertising? Talk to our sales team today and learn how Angi can help grow your business.")), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: 12,
        md: 6,
        mdPush: 3
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        bsStyle: "primary-office",
        bsSize: "small",
        id: "office-home--advertise-with-us--submit-request-button",
        onClick: function onClick() {
          return advertiseRequest(activityLocation, 'Generic CTA', categorySegmentData);
        },
        loading: advertiseRequestPending,
        disabled: advertiseRequestPending,
        style: {
          width: '100%'
        },
        flat: true
      }, "Start Advertising on Angi"))));
    }
  }]);
  return AdvertiseWithUsDynamic;
}(_react["default"].Component);

exports.AdvertiseWithUsDynamic = AdvertiseWithUsDynamic;
var _default = AdvertiseWithUsDynamic;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/AdvertiseWithUsDynamic.js
// module id = 3676
// module chunks = 25